/* eslint-disable max-len */
import PropTypes from 'prop-types'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { positionPropType } from '../common/position-prop-type'

/**
 * @typedef {Object} CrashLog
 *
 * @property {object}               acceleration                        - The acceleration vector with x, y and z components in mg
 * @property {ISO8601}              timestamp                           - The date of the crash log (ISO8601).
 * @property {Position}             [position]                          - The geo position of the crash log (decimal degree).
 * @property {number}               [speed]                             - The speed registered during the crash log
 */
export const crashLogPropType = PropTypes.shape({
    acceleration: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        z: PropTypes.number
    }).isRequired,
    position: positionPropType,
    speed: PropTypes.number,
    timestamp: iso8601PropType.isRequired
})
